<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="problemFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <problem-filter-form-item
        :form="form"
        :field="field"
        :options="{
          statusList: problemStatus,
          channels: problemChannels,
          urgencys: problemUrgencys,
          projectOptions: projectOptions
        }"
        :search-data="{
          story: {
            searching: storySearching,
            data: searchStoryData
          }
        }"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
        @search="handleFieldSearch"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { projectList } from '@/api/project/project';
import { problemStatus, problemChannels, problemUrgencys } from '@/utils/dictionary';

import CommonFilterForm from '@/components/CommonFilterForm';
import ProblemFilterFormItem from '@/pages/event/components/ProblemFilterFormItem';

export default {
  name: 'ProblemFilterForm',
  components: {
    CommonFilterForm,
    ProblemFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      storySearching: false,
      searchStoryData: [],
      problemStatus,
      problemChannels,
      problemUrgencys,
      projectOptions: [],
      // 所有可用的筛选项配置
      allFields: [
        { key: 'title', label: '标题', span: 6 },
        { key: 'status', label: '状态', span: 6 },
        { key: 'handler', label: '处理人', span: 6 },
        { key: 'reporter', label: '反馈人', span: 6 },
        { key: 'projects', label: '项目', span: 6 },
        { key: 'urgency', label: '紧急程度', span: 6 },
        { key: 'dateRange', label: '时间筛选', span: 12, labelSpan: 3, wrapperSpan: 21 },
        { key: 'channel', label: '反馈渠道', span: 6 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['title', 'status', 'handler'],
      // 默认更多筛选字段
      defaultMoreFields: ['reporter', 'projects', 'urgency', 'dateRange', 'channel']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getProjectList();
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      // 定义默认的筛选表单值
      const defaultForm = {
        time_field: 'reported_time',
        start_time: null,
        end_time: null
      };
      // 更新表单数据
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    },

    handleFieldSearch({ key, value }) {
      if (key === 'story') {
        this.searchStory(value);
      }
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projectOptions = res.data.projects;
      });
    },

    // 搜索需求
    searchStory(value) {
      this.storySearching = true;
      // TODO: 实现需求搜索
      this.storySearching = false;
    }
  }
};
</script>

<style lang="less" scoped>
.problem-filter-form {
  .filter-actions {
    display: flex;
    text-align: right;
    margin-left: auto;
    align-items: flex-start;
    justify-content: flex-end;
  }

  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }

  :deep(.filter-popover) {
    .ant-popover-inner-content {
      padding: 0;
    }
  }

  .filter-popover-content {
    width: 520px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 12px;

    .filter-sections {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .filter-section {
        h3 {
          margin-bottom: 4px;
          color: #495057;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.2;
        }

        .field-list {
          .field-item {
            display: flex;
            align-items: center;
            cursor: move;

            .drag-handle {
              padding: 2px;
              cursor: move;
              opacity: 0.4;
              display: flex;
              align-items: center;
              transition: all 0.2s ease;

              &:hover {
                opacity: 0.7;
              }
            }

            :deep(.ant-form-item) {
              flex: 1;
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
